import { Component, OnInit } from '@angular/core';
import { Pagination } from 'src/app/core/pagination/pagination';
import { UploadMissedActionDataValidationHistoryService } from '../upload-missed-action-data-validation-history/upload-missed-action-data-validation-history.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { NotifierService } from 'angular-notifier';
import { HeaderService } from 'src/app/core/header/header.service';

@Component({
  selector: 'app-upload-missed-action-data-validation-history',
  templateUrl: './upload-missed-action-data-validation-history.component.html',
  styleUrls: ['./upload-missed-action-data-validation-history.component.scss']
})
export class UploadMissedActionDataValidationHistoryComponent implements OnInit {
  public wrapText: boolean = false;
  public pagination: Pagination | any;
  public showLoader: boolean = false;
  public currentPage: number | any;
  public totalPages: number | any;
  public missedActionDataList: any = [];
  public filteredData: any = [];
  public totalRecordsForPagination: number = 0;
  public errorMessage: any = '';
  private readonly notifier: NotifierService;
  public columnValueList: any = null;

  public filters = {
    jobID: '',
    fileName: '',
    startDate: '',
    endDate: '',
    status: ''
  };

  constructor(
    private uploadMissedActionDataValidationHistoryService: UploadMissedActionDataValidationHistoryService,
    private errorHandler: ErrorHandlerService,
    private notifierService: NotifierService,
    private headerService: HeaderService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.pagination = new Pagination("MissedActionDataFileName", true, 1);
    this.GetMissedActionData(this.pagination);
  }

  GetMissedActionData(paginationdetail: any) {
    if (paginationdetail) {
      this.pagination.pageIndex = paginationdetail.pageIndex;
      this.currentPage = this.pagination.pageIndex;
    }
    this.pagination.pageLength = this.pagination.pageLength;
    this.pagination.clientMasterId = this.headerService.user.ClientMasterID;
    this.showLoader = true;
    this.uploadMissedActionDataValidationHistoryService.Get(this.pagination).subscribe({
      next: (data: any) => {
        this.showLoader = false;
        this.totalPages = data.Data.TotalPage;
        this.currentPage = data.Data.CurrentIndex;
        this.missedActionDataList = data.Data.Data;
        this.totalRecordsForPagination = data.Data.TotalRecordsForPagination;
        this.applyFilters();
      },
      error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Workbench", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  applyFilters() {
    this.filteredData = this.missedActionDataList.filter((item: any) => {
      return (
        (this.filters.jobID === '' || (item.JobID && item.JobID.toLowerCase().includes(this.filters.jobID.toLowerCase()))) &&
        (this.filters.fileName === '' || (item.MissedActionDataFileName && item.MissedActionDataFileName.toLowerCase().includes(this.filters.fileName.toLowerCase()))) &&
        (this.filters.startDate === '' || (item.MissedActionDataStartDate && item.MissedActionDataStartDate.toLowerCase().includes(this.filters.startDate.toLowerCase())) || (!item.MissedActionDataStartDate && this.filters.startDate === '')) &&
        (this.filters.endDate === '' || (item.MissedActionDataEndDate && item.MissedActionDataEndDate.toLowerCase().includes(this.filters.endDate.toLowerCase())) || (!item.MissedActionDataEndDate && this.filters.endDate === '')) &&
        (this.filters.status === '' || (item.Status && item.Status.toLowerCase().includes(this.filters.status.toLowerCase())))
      );
    });
    // Apply sorting after filtering
    this.sortData(this.pagination.columnName);
  }

  sortData(column: string) {
    if (this.pagination.columnName === column) {
      this.pagination.ascending = !this.pagination.ascending;
    } else {
      this.pagination.columnName = column;
      this.pagination.ascending = true;
    }

    // Perform sorting in-memory
    this.filteredData.sort((a: any, b: any) => {
      let comparison = 0;
      const valA = a[column] ?? '';
      const valB = b[column] ?? '';

      // Determine if the column is numeric or date
      if (!isNaN(valA) && !isNaN(valB)) {
        // Numeric comparison
        comparison = Number(valA) - Number(valB);
      } else if (!isNaN(new Date(valA).getTime()) && !isNaN(new Date(valB).getTime())) {
        // Date comparison
        comparison = new Date(valA).getTime() - new Date(valB).getTime();
      } else {
        // String comparison
        const strA = valA.toUpperCase();
        const strB = valB.toUpperCase();
        if (strA > strB) {
          comparison = 1;
        } else if (strA < strB) {
          comparison = -1;
        }
      }

      return this.pagination.ascending ? comparison : -comparison;
    });
  }

  GetUsersByPageLength() {
    this.pagination.pageIndex = 1;
    this.GetMissedActionData(this.pagination);
  }
}
